import {
  PrispevokVestnikaInfoListApi,
  PrispevokVestnikaInfo as PrispevokVestnikaInfoGenerated,
} from 'vestniky-frontend-ts-axios';
import { vestnikyPrefixPath } from './configuration/apiConfigurationConstants';
import PrispevokVestnikaInfo from '../model/PrispevokVestnikaInfo';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/types/ClientResponse';
import Organizacia from '../model/ciselniky/Organizacia';

const client = new PrispevokVestnikaInfoListApi(apiConfiguration(vestnikyPrefixPath));

function map(prispevokInfoList: PrispevokVestnikaInfoGenerated[], vestnik: Organizacia): PrispevokVestnikaInfo[] {
  return prispevokInfoList.map(prispevok => ({
    uuid: prispevok.uuid,
    vestnikUuid: prispevok.vestnikUuid,
    nazov: prispevok.nazov,
    kratkyNazov: prispevok.kratkyNazov,
    cislo: prispevok.cislo,
    // eslint-disable-next-line max-len
    menovka: `${vestnik.skratenyNazov} ${prispevok.cislo}/${prispevok.datumZverejnenia?.split('-')[0]} ${prispevok.nazov}`,
    menovkaSkratena: `${vestnik.skratenyNazov} ${prispevok.cislo}/${prispevok.datumZverejnenia?.split('-')[0]}`,
  }));
}

// eslint-disable-next-line import/prefer-default-export
export const fetchPrispevokVestnikaInfoList = async (
  vestnik: Organizacia,
  hladanyNazov: string,
  limit: number,
  options?: { headers?: object },
):
  Promise<ClientResponse<PrispevokVestnikaInfo[]>> => {
  const {
    data,
    status,
  } = await client.getPrispevokVestnikaList(vestnik.uuid, hladanyNazov, limit, options);
  return {
    data: map(data, vestnik),
    responseCode: status,
  };
};
